import {
  ComponentDescriptions,
  Dolan,
  StyleClassDefinitionsByComponentId,
} from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import { lruMemoize } from '@reduxjs/toolkit';
import { mergeStyleClasses } from '../../../modules/style-classes';
import { getComponentTemplateStyleClasses } from '../../../modules/components';

const mergeSelectedStyleClasses = lruMemoize(
  (
    appStyleClasses: StyleClassDefinitionsByComponentId | undefined,
    themeStyleClasses: StyleClassDefinitionsByComponentId | undefined,
    componentDescriptions: ComponentDescriptions | undefined,
  ): StyleClassDefinitionsByComponentId => {
    const componentTemplateStyleClasses = getComponentTemplateStyleClasses(componentDescriptions);
    return mergeStyleClasses(appStyleClasses, themeStyleClasses, componentTemplateStyleClasses);
  },
);

const getMergedStyleClasses = (dolan: Dolan | null | undefined) =>
  mergeSelectedStyleClasses(dolan?.style_classes, dolan?.theme_meta?.style_classes, dolan?.components);

export default getMergedStyleClasses;
